import { trim } from 'lodash';
import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import useHardwareScanner from 'common/hooks/useHardwareScanner';
import useRoles from 'common/hooks/useRoles';

// Same minimum as SearchOrderDialog's order id search.
const MIN_ORDER_ID_LENGTH = 5;

// The Rx Scan Station consumes hardware scans itself (Rx bottle barcodes).
const SCANNER_OWNED_PATHS = ['/rx-scan'];

// An open MUI Dialog/Menu/Popover means the operator is mid-task — don't yank
// them off the page for a stray scan.
const isModalOpen = () => !!document.querySelector('.MuiModal-root:not(.MuiModal-hidden)');

/**
 * Anywhere outside the Rx Scan Station, a hardware barcode scan of an order id
 * opens that order's view. Scans into a focused input are left alone (see
 * useHardwareScanner).
 */
const GlobalOrderScanner = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { viewOrdersList: hasOrdersAccess } = useRoles();

  const enabled = hasOrdersAccess && !SCANNER_OWNED_PATHS.includes(pathname);

  const handleScan = useCallback(
    (code) => {
      const orderId = trim(code);
      if (orderId.length < MIN_ORDER_ID_LENGTH || isModalOpen()) return;

      navigate(`/orders/${encodeURIComponent(orderId)}`);
    },
    [navigate]
  );

  useHardwareScanner(handleScan, { enabled });

  return null;
};

export default GlobalOrderScanner;
